import { publicAxiosInstance } from '@configs/axios/public-axios/publicAxiosInstance';

import type { RegisterUserRequest } from './registerUser.types';

export async function registerUser(data: RegisterUserRequest): Promise<void> {
  await publicAxiosInstance.post(
    '/users/onboard-visitors',
    data
  );
}
